// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"73":"36214ead","460":"2bf8bb7e","778":"116595ad"}[chunkId] + ".js";
};